import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

const Wishlist = props => {
  let icon = ''
  if (props.loading) {
    icon = (
      <Icon
        iconName='icon_options'
        className='txt-body-lg pointer'
        aria-label='Adicionar a adicionar na lista de desejo'
      />
    )
  } else if (props.removed || props.notAdded) {
    icon = (
      <Icon
        iconName={props.inWishlist ? 'icon_wishlist_color' : 'icon_wishlist'}
        className='txt-body-lg pointer'
        onClick={
          props.inWishlist
            ? () => props.removeWishlist(props.skuId)
            : () => props.addWishlist(props.skuId)
        }
        role='button'
        aria-label='Adicionar na lista de desejos'
      />
    )
  } else if (props.error) {
    icon = (
      <Icon
        iconName='icon_close_circle'
        className='color-error h4  d-inline-block pointer'
        aria-label='Erro ao adicionar na lista de desejo'
      />
    )
  } else {
    icon = (
      <Icon
        iconName='icon_wishlist_color'
        className='txt-body-lg color-error pointer'
        onClick={() => {
          props.removeWishlist(props.skuId)
        }}
        role='button'
        aria-label='Remover da lista de desejos'
      />
    )
  }

  return icon
}

Wishlist.propTypes = {
  skuId: PropTypes.string,
  loading: PropTypes.bool,
  removed: PropTypes.bool,
  error: PropTypes.string,
  addWishlist: PropTypes.func,
  removeWishlist: PropTypes.func,
  inWishlist: PropTypes.bool
}

export default Wishlist



// WEBPACK FOOTER //
// ./src/features/WishlistHeart/WishlistHeart.js